module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("CHOOSE"), _c('br'), _vm._v("YOUR"), _c('br'), _c('span', {
    staticClass: "title1"
  }, [_vm._v("RETIREMENT")])]), _vm._v(" "), _c('h2', {
    staticClass: "description"
  }, [_vm._v("FIND THE RIGHT PATH TO YOUR NEW ADVENTURE")]), _vm._v(" "), _c('h2', {
    staticClass: "author"
  }, [_vm._v("Emily Guy Birken"), _c('br'), _c('span', {
    staticClass: "author1"
  }, [_vm._v("Author of "), _c('i', [_vm._v("The 5 Years Before You Retire")])])]), _vm._v(" "), _c('p', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/logo.gif"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "publisher"
  }, [_vm._v("Avon, Massachusetts")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb7c5694","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Title.vue
// module id = 63
// module chunks = 0